import BrowseFurniture from "@components/Components/HomeComponent/EH/BrowseFurniture";
import Home from "@components/Components/HomeComponent/EH/Home";
import PageContextWrapper from "@components/Components/Reusables/PageContextWrapper";
import { getBrand } from "@components/config/helpers";
import dynamic from "next/dynamic";
import { handleRateLimit } from "utils/handleRateLimit";



//Dynamically load the home component and return it
const Page = ({ data }) => {
    return (
        <PageContextWrapper
            page='home'
            page_content={data?.template_page_content}
        >

            <BrowseFurniture homeData={data}/>

        </PageContextWrapper>
    );
};

export async function getServerSideProps({ query, res, req }) {

    try {

        if(!getBrand('EH')) return {notFound: true}
        
        const request = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}get-home-content`);
        let data = await request.json();
    
        const rateLimitRedirect = handleRateLimit(res, data);
        if (rateLimitRedirect) return rateLimitRedirect;

        if(data.exception) {
            return {notFound: true}
        }
    
        res.setHeader(
            'Cache-Control',
            'public, s-maxage=43200, stale-while-revalidate=59'
        )
    
        // Pass data to the page via props
        return {
            props: { data },
        };
    } catch (error) {
        return {
            props: {
                error: true,
                statusCode: 500

            }
        }
        
    }
}

export default Page;
